var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudOff24Px(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0L3 1L6 4H5C2.00993 4.31753 0 6.93385 0 10C0 13.2845 2.71192 16 6 16H18L20 18L21 17L4 0ZM24 11C24 8.32613 21.6581 6.18231 19 6C18.3048 2.50574 15.7214 0 12 0C10.6403 0 9.10415 0.382174 8 1L10 2C10.4436 1.80977 10.8213 1.86595 11.2463 1.92915C11.4775 1.96354 11.7226 2 12 2C15.108 2 17 4.921 17 8H19C20.6971 8 22 9.3187 22 11C22 12.0027 21.7463 13.4429 21 14L22 15C23.1144 14.0682 24 12.5598 24 11ZM2 10C2 12.21 3.74654 14 6 14H16L8 6H6C3.74654 6 2 7.79 2 10Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudOff24Px);
export default __webpack_public_path__ + "static/media/cloud_off_24px.c9086fff9fbd4652c9158702f26e1c52.svg";
export { ForwardRef as ReactComponent };